<script setup>
import { computed } from 'vue';
import { rangeText, avg, fmt, sampleLabel, flagClass, computeFlag } from '../utils/format.js';

const props = defineProps({
	samples: { type: Array, required: true },
	columns: { type: Array, required: true },
	striped: { type: Boolean, default: false }
});

function columnFlag(col, sample) {
	if (col.flag) return col.flag(sample);
	if (col.flagFromComputed) return computeFlag(col.get(sample), col.range);
	return null;
}

function cellClass(col, sample) {
	const flag = columnFlag(col, sample);
	return flag ? flagClass(flag) : '';
}

const averages = computed(() => props.columns.map(c => avg(props.samples.map(c.get))));
</script>

<template>
	<table class="table table-bordered tnt-flag-table" :class="{ 'table-striped': striped }">
		<thead>
			<tr>
				<th>Sample</th>
				<th v-for="(col, i) in columns" :key="i">
					{{ col.label }}<span class="tnt-unit">{{ col.unit ? ' (' + col.unit + ')' : '' }}</span>
					<span class="tnt-range">{{ col.range ? rangeText(col.range) : '' }}</span>
				</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="(sample, si) in samples" :key="si">
				<td>{{ sampleLabel(sample) }}</td>
				<td v-for="(col, ci) in columns" :key="ci" :class="cellClass(col, sample)">
					{{ fmt(col.get(sample)) }}
				</td>
			</tr>
			<tr class="tnt-avg-row">
				<td>Average</td>
				<td v-for="(a, i) in averages" :key="i">{{ fmt(a) }}</td>
			</tr>
		</tbody>
	</table>
</template>
